import {FC, useContext, useEffect, useRef, useState} from "react";
import {useNavigate, useParams} from "react-router-dom";
import {Box, Button} from "@mui/material";
import {makeStyles} from "tss-react/mui";
import {ModuleNotAvailable} from "@buildwitt/shapeshift-common/v1/module";
import {VideoPlayerRef} from "@buildwitt/shapeshift-common/v1/videoPlayer/videoPlayer";
import "bitmovin-player/bitmovinplayer-ui.css";
import {LocaleContext} from "../../../contexts/localeContext";
import {PageBaseContext} from "../../../contexts/pageBaseContext";
import AnnouncementDataProvider from "@/providers/announcementDataProvider";
import { AnnouncementContext } from "@/contexts/announcementContext";
import { IAnnouncement } from "@/types/announcement";
import { AnnouncementPageContent } from "./AnnouncementPageContent";

const useStyles = makeStyles()((theme) => ({
	announcementPage: {
	},
	goToNextAnnouncement: {
		marginTop: "25px"
	},
	notAvailableContainer: {
		width: "100%",
		textAlign: "center"
	},
	announcementCompleteBtn: {
		float: "right"
	},
}));

export const AnnouncementPage: FC = () => {
	const {classes} = useStyles();
	const {slug: announcementSlug} = useParams();
	const [{contentContainerRef}] = useContext(PageBaseContext);
	const navigate = useNavigate();
	const videoRef = useRef<VideoPlayerRef | null>(null);
	const [{locale}] = useContext(LocaleContext);
	const {announcementState, announcementDispatch} = useContext(AnnouncementContext);
	const [firstAvailableModule, setFirstAvailableAnnouncement] = useState<IAnnouncement | false>();
	
	useEffect(() => {
		if(announcementState){
			const next = announcementState.find(e => e.slug !== announcementSlug && e.complete === false);
			setFirstAvailableAnnouncement(next)
		}
	}, [])


	useEffect(() => {
		videoRef.current = null;
		if (contentContainerRef?.current) {
			contentContainerRef.current.scrollTo({top: 0, behavior: "smooth"});
		}
	}, [announcementSlug])

	return (
		<Box className={classes.announcementPage}>
			<AnnouncementDataProvider locale={locale} announcementSlug={announcementSlug} populate={["files", "enrollment.videoTime"]}>
				{({announcement, apiResult}) => {
					return <>
						{(apiResult.statusCode === 200 && announcement) && <AnnouncementPageContent announcement={announcement}/>}
						{apiResult.statusCode === 403 && <Box className={classes.notAvailableContainer}>
							<ModuleNotAvailable>
								Announcements must be completed in sequence.
							</ModuleNotAvailable>
							{firstAvailableModule && <Button
								className={classes.goToNextAnnouncement}
								onClick={() => navigate(`/announcement/${firstAvailableModule?.slug}`)}
							>
							Go to next available announcement
							</Button>}
							{announcement?.slug && announcement?.complete && firstAvailableModule &&
								<Button
									onClick={() => navigate("/training-feed")}
									className={classes.announcementCompleteBtn}
								>
									Next {firstAvailableModule ? firstAvailableModule?.type : ""}
								</Button>
							}
						</Box>}
					</>}
				}
			</AnnouncementDataProvider>
		</Box>
	);
}